import { Route } from "vue-router";
import yaml from "js-yaml";
import axios from "axios";

export default class ConfigService {
  private static _instance: ConfigService;
  public backEndUrl = process.env.VUE_APP_BACKEND || "http://localhost:49173";
  public adminAppUrl = process.env.VUE_APP_FRONTEND || "http://localhost:8081";
  public websiteUrl = "https://mantle.technology";

  public static get Instance() {
    return this._instance || (this._instance = new ConfigService());
  }
}
